// extracted by mini-css-extract-plugin
export default {"otp_open":"ResetPasswordForm_otp_open__Wvs9c","otp_open_error":"ResetPasswordForm_otp_open_error__1+Xul"};